import script from "./HomeLoginRegisterTeaser.vue?vue&type=script&setup=true&lang=ts"
export * from "./HomeLoginRegisterTeaser.vue?vue&type=script&setup=true&lang=ts"

import "./HomeLoginRegisterTeaser.vue?vue&type=style&index=0&id=fcfe1470&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fcfe1470"]])

export default __exports__